export enum RxAttachmentsVisibiltyEnum {
	Invisible = 'Invisible',
	ShowReplacement = 'ShowReplacement',
	ShowAllowSendLater = 'ShowAllowSendLater',
	ShowAttachments = 'ShowAttachments'
}